<template>
  <div class="processedDetail">
    <div style="font-size: 24px; margin-bottom: 20px; font-weight: bold">
      {{ $t('aside.ScanPrint') }}
    </div>
    <div class="IdScaneArea">
      <!-- 扫描区 -->
      <el-input
        size="mini"
        ref="scan"
        v-model="scanNum"
        :placeholder="$t('homeTwo.Scanarea')"
        @change="packBageOutCopy()"
      >
      </el-input>
    </div>
    <div class="ppo_box">
      <div class="titl_desc_right">
        <div>
          <!-- <el-button
            size="medium"
            type="primary"
            ref="printBtn"
            v-print="printConfig"
            >{{ $t("other.a342") }}</el-button
          > -->
          <el-button
            size="medium"
            type="primary"
            @click="packBageOutCopy()"
            >{{ $t("other.a342") }}</el-button
          >
        </div>
      </div>
    </div>
    <img
      id="printImg"
      :src="image"
      style="width: 102mm; display: block; margin: 0"
    />
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import utils from "../../../utils/utils.js";
import * as pdfjsLib from "pdfjs-dist";
import pdfjsWorker from "pdfjs-dist/build/pdf.worker.entry";
import orders from '../../../api/moudles/order'


import axios from "axios";
export default {
  data() {
    return {
      scanNum: "",
      image: "",
      // v-print打印配置【80mm小票，无多余白边、不空白分页】
      printConfig: {
        id: "printImg",
        popTitle: "", // 去除页眉标题
        showHeaderFooter: false, // 关闭页眉页脚
        extraCss: `@page {size:80mm auto;margin:0mm;}
        body{margin:0;padding:0;}`,
        // 打印结束回调
        closeCallback: () => {
          this.image = ""; //清空图片
          this.scanNum = ""; //清空扫码
          this.$refs.scan.focus(); //继续扫码
        },
      },

    };
  },
  directives: {
    //注册一个局部的自定义指令 v-focus
    focus: {
      // 指令的定义
      inserted: function (el) {
        // 聚焦元素
        el.querySelector("scan").focus();
      },
    },
  },
  computed: {
    ...mapState({
      userId: (state) => state.login.userInfo.userId || "",
    }),
  },
  watch: {},
  mounted() {
    // 页面加载自动聚焦扫码框
    this.$nextTick(() => {
      this.$refs.scan.focus();
    });
  },
  created() {},
  methods: {
    async loadPdf(url) {
      const loadingTask = pdfjsLib.getDocument(url);
      const pdf = await loadingTask.promise;
      let imgUrl = null;
      for (let i = 1; i <= pdf.numPages; i++) {
        const page = await pdf.getPage(i);
        const viewport = page.getViewport({ scale: 5 });

        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");

        var CSS_UNITS = 96.0 / 72.0;
        console.log(CSS_UNITS);
        canvas.height = viewport.height;
        canvas.width = viewport.width;
        // canvas.height = Math.floor(viewport.height * CSS_UNITS);
        // canvas.width = Math.floor(viewport.width * CSS_UNITS) ;

        // 计算物理像素比

        await page.render({
          // transform: [CSS_UNITS, 0, 0, CSS_UNITS, 0, 0],
          canvasContext: context,
          viewport: viewport,
          intent: "quality",
        }).promise;

        // this.pageImages.push(canvas.toDataURL('image/png'))
        // console.log(this.pageImages)
        imgUrl = canvas.toDataURL("image/jpeg");
        this.downloadBase64Img(this.changeDpiDataUrl(imgUrl, 300));
      }
    },
    downloadBase64Img(base64URL) {
      // 创建 Blob 对象，并获取 base64 数据的 MIME 类型
      const mimeType = base64URL.match(/:(.*?);/)[1];
      // 将 base64 数据转换为字节数组
      const byteCharacters = atob(base64URL.split(",")[1]);
      const byteNumbers = new Array(byteCharacters.length);
      // 将字节数组填充到 Uint8Array 中
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      // 创建 Blob 对象
      const blob = new Blob([byteArray], {
        type: mimeType,
      });
      // 将 Blob 对象的 URL 赋值给 a 标签的 href 属性
      // a.href = URL.createObjectURL(blob);
      this.image = URL.createObjectURL(blob);

      // DOM渲染完，自动点击隐藏按钮触发打印
      this.$nextTick(() => {
        console.log(this.$refs);
        this.$refs.printBtn.$el.click();
      });
    },
    changeDpiDataUrl(base64Image, dpi) {
      const PNG = "image/png";
      const JPEG = "image/jpeg";
      const dataSplitted = base64Image.split(",");
      const format = dataSplitted[0];
      const body = dataSplitted[1];
      let type;
      let headerLength;
      let overwritepHYs = false;
      if (format.indexOf(PNG) !== -1) {
        type = PNG;
        const b64Index = detectPhysChunkFromDataUrl(body);
        // 28 bytes in dataUrl are 21bytes, length of phys chunk with everything inside.
        if (b64Index >= 0) {
          headerLength = Math.ceil((b64Index + 28) / 3) * 4;
          overwritepHYs = true;
        } else {
          headerLength = (33 / 3) * 4;
        }
      }
      if (format.indexOf(JPEG) !== -1) {
        type = JPEG;
        headerLength = (18 / 3) * 4;
      }
      // 33 bytes are ok for pngs and jpegs
      // to contain the information.
      const stringHeader = body.substring(0, headerLength);
      const restOfData = body.substring(headerLength);
      const headerBytes = atob(stringHeader);
      const dataArray = new Uint8Array(headerBytes.length);
      for (let i = 0; i < dataArray.length; i++) {
        dataArray[i] = headerBytes.charCodeAt(i);
      }
      const finalArray = this.changeDpiOnArray(
        dataArray,
        dpi,
        type,
        overwritepHYs
      );
      const base64Header = btoa(String.fromCharCode(...finalArray));

      return [format, ",", base64Header, restOfData].join("");
    },
    changeDpiOnArray(dataArray, dpi, format, overwritepHYs) {
      // console.log(3)
      const PNG = "image/png";
      const JPEG = "image/jpeg";

      if (format === JPEG) {
        dataArray[13] = 1; // 1 pixel per inch or 2 pixel per cm
        dataArray[14] = dpi >> 8; // dpiX high byte
        dataArray[15] = dpi & 0xff; // dpiX low byte
        dataArray[16] = dpi >> 8; // dpiY high byte
        dataArray[17] = dpi & 0xff; // dpiY low byte
        return dataArray;
      }
      if (format === PNG) {
        const physChunk = new Uint8Array(13);
        // chunk header pHYs
        // 9 bytes of data
        // 4 bytes of crc
        // this multiplication is because the standard is dpi per meter.

        const _P = "p".charCodeAt(0);
        const _H = "H".charCodeAt(0);
        const _Y = "Y".charCodeAt(0);
        const _S = "s".charCodeAt(0);
        dpi *= 39.3701;
        physChunk[0] = _P;
        physChunk[1] = _H;
        physChunk[2] = _Y;
        physChunk[3] = _S;
        physChunk[4] = dpi >>> 24; // dpiX highest byte
        physChunk[5] = dpi >>> 16; // dpiX veryhigh byte
        physChunk[6] = dpi >>> 8; // dpiX high byte
        physChunk[7] = dpi & 0xff; // dpiX low byte
        physChunk[8] = physChunk[4]; // dpiY highest byte
        physChunk[9] = physChunk[5]; // dpiY veryhigh byte
        physChunk[10] = physChunk[6]; // dpiY high byte
        physChunk[11] = physChunk[7]; // dpiY low byte
        physChunk[12] = 1; // dot per meter....

        const crc = calcCrc(physChunk);

        const crcChunk = new Uint8Array(4);
        crcChunk[0] = crc >>> 24;
        crcChunk[1] = crc >>> 16;
        crcChunk[2] = crc >>> 8;
        crcChunk[3] = crc & 0xff;

        if (overwritepHYs) {
          const startingIndex = searchStartOfPhys(dataArray);
          dataArray.set(physChunk, startingIndex);
          dataArray.set(crcChunk, startingIndex + 13);
          return dataArray;
        } else {
          // i need to give back an array of data that is divisible by 3 so that
          // dataurl encoding gives me integers, for luck this chunk is 17 + 4 = 21
          // if it was we could add a text chunk contaning some info, untill desired
          // length is met.

          // chunk structur 4 bytes for length is 9
          const chunkLength = new Uint8Array(4);
          chunkLength[0] = 0;
          chunkLength[1] = 0;
          chunkLength[2] = 0;
          chunkLength[3] = 9;

          const finalHeader = new Uint8Array(54);
          finalHeader.set(dataArray, 0);
          finalHeader.set(chunkLength, 33);
          finalHeader.set(physChunk, 37);
          finalHeader.set(crcChunk, 50);
          return finalHeader;
        }
      }
    },
    async getPreviewUrl(ossUrl) {
      const res = await axios.get(ossUrl, { responseType: "blob" });
      const blob = new Blob([res.data], { type: "application/pdf" });
      const blobUrl = URL.createObjectURL(blob);
      let iframe = document.createElement("iframe");
      iframe.style.display = "none";
      document.body.appendChild(iframe);
      iframe.src = blobUrl;
      // 改用延时等待渲染，不使用onload立刻打印
      setTimeout(() => {
        iframe.contentWindow.print();
        // 打印后延迟清理iframe，防止还没操作就销毁
        setTimeout(() => {
          document.body.removeChild(iframe);
          URL.revokeObjectURL(blobUrl);
        }, 2000);
      }, 1200);
    },

    // 使用：赋值给img/src/pdfjs，直接渲染、v-print打印，不会下载
    // let pdfSrc = await getPreviewUrl(ossUrl)
    // this.image = pdfSrc

    packBageOutCopy() {
      this.scanNum = this.scanNum.trim();
      if (this.scanNum) {

        orders.scanOutbound(this.userId,this.scanNum).then(async res=>{
          console.log(res)
          if(res.code == 200){
            await this.getPreviewUrl(res.data.PDF.pdf);

            // 打印结束清空扫码
            this.scanNum = "";
            this.$refs.scan.focus();
          }else{
            this.$message.error(res.msg)
          }
        })

        // this.loadPdf('https://xianggangxxerp.oss-cn-hongkong.aliyuncs.com/pdf/PO-211-07891574223992595.pdf')
        // this.loadPdf("/ddxapi/pdf/PO-211-07891574223992595.pdf");

        // await this.getPreviewUrl(this.scanNum);

        // // 打印结束清空扫码
        // this.scanNum = "";
        // this.$refs.scan.focus();
      } else {
        return;
      }
    },
  },
};
</script>

<style>
.processedDetail {
  position: absolute;
  width: 100%;
  box-sizing: border-box;
  padding: 0 20px;
  margin-top: 20px;
}

.processedDetail .sbti {
  font-size: 25px;
  color: red;
  font-weight: bold;
}

.processedDetail .sbtiCopy {
  font-size: 25px;
  color: rgb(0, 199, 163);
  font-weight: bold;
}

.processedDetail .orderInfo {
  font-size: 18px;
}

.processedDetail .bvmt {
  margin: 20px 0;
}

.processedDetail .orderInfo_item {
  margin: 0 10px;
}

.processedDetail .order-list-item {
  position: relative;
  padding-bottom: 10px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.processedDetail .order-title {
  border-bottom: 1px #e0e0e0 solid;
}

.processedDetail .order-title-count {
  color: red;
  font-style: inherit;
  margin-left: 10px;
}

.processedDetail .order-query {
  display: flex;
  justify-content: start;
  align-items: center;
  padding: 10px;
  border-bottom: 1px #e0e0e0 solid;
}

.el-tooltip__popper.is-dark {
  background: #000000 !important;
}

.processedDetail .order-query .query {
  position: relative;
  margin-right: 30px;
}

.processedDetail .list-btn {
  padding: 20px 15px;
}

.processedDetail .list-desc {
  margin-left: 15px;
  border-bottom: 1px #eee solid;
}

.processedDetail .list-desc-item {
  font-size: 14px;

  padding-right: 15px;
}

.icon-box {
  width: 22px;
  height: 22px;
  cursor: pointer;
  display: inline-block;
}
.icon-box.svg-box:hover {
  color: tomato;
}

.processedDetail .list-item-status {
  color: red;
}

.processedDetail .didan {
  font-size: 24px;
}

.processedDetail .list-content {
  display: flex;
  justify-content: space-around;
  /* margin: 20px;
	padding: 20px; */
  /* box-shadow: 0 2px 12px 0 rgba(0,0,0,.1); */
}

.processedDetail .order-pic {
  width: 80px;
  height: 80px;
}

img {
  width: 100%;
}

.processedDetail .list-content-left,
.list-content-right {
  display: flex;
}

.processedDetail .list-item-wrapper {
  box-sizing: border-box;
  padding: 15px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.processedDetail .order-selec {
  width: 150px;
  margin: 0 10px;
}

.processedDetail .block-ttp {
  width: 350px !important;
}

.processedDetail .titl_desc_right {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}

.processedDetail .order-desc {
  width: 30%;
}

.processedDetail .order-title-desc {
  margin-bottom: 15px;
}

.stroeVisble .el-input__inner {
  width: 99%;
  height: 130px;
  font-size: 30px;
}

.processedDetail .list-price-item,
.shoper-name {
  padding: 2px 0;
}

.processedDetail .list-number,
.list-price {
  margin-left: 40px;
}

.list-price-btn {
  display: flex;
  flex-direction: column;
}

.list-price-btn-item {
  margin-top: 20px;
  margin-left: 0 !important;
  width: 120px;
}

.processedDetail .primary-btn {
  display: inline-block;
  margin: 0 30px;
}

.second-menu-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.asb {
  position: relative;
}

.dialog-wrapper {
  display: flex;
  flex-wrap: wrap;
  position: absolute;
  top: 50px;
  left: -600px;
  bottom: 0;
  right: 0;
  width: 600px;
  background-color: #fff;
  margin: 0 auto;
  z-index: 40;
  box-shadow: 0 0 25px #cac6c6;
}

.dialog-wrapper-item {
  display: inline-block;
  width: 100px;
  height: 100px;
  box-sizing: border-box;
  background-color: #fff;
  padding: 5px;
}

.processedDetail .second-menu {
  display: flex;
  justify-content: flex-start;
  position: relative;
}

.processedDetail .menu-right-btn {
  margin-right: 30px;
  color: #606266;
}

.el-icon-loading:before {
  content: "\E6CF";
  font-size: 20px;
}

.processedDetail .second-menu-left {
  display: flex;
}

.icon-gouxuanxuanzhongtai {
  color: rgb(0, 199, 163);
  font-size: 25px;
  margin-left: 20px;
}

.icon-jinggao1 {
  color: rgb(255, 82, 69);
  font-size: 25px;
  margin-left: 20px;
}

.processedDetail .sousuo-box {
  width: 300px;
  margin-right: 20px;
}

.processedDetail .chekbox {
  width: 30px;
  height: 30px;
}

.processedDetail .Pager {
  position: fixed;
  bottom: 0;
  left: 235px;
  right: 0;
  height: 40px;
  line-height: 40px;
  background-color: #fff;
  text-align: right;
}

.processedDetail .el-pagination {
  display: flex;
  justify-content: flex-end;
  margin: 0 10px 10px 0;
}

.processedDetail .nodata {
  margin-top: 100px;
  text-align: center;
  color: #000;
}

.processedDetail .checkallbox {
  margin: 7px;
  padding-left: 5px;
  color: #606266;
  font-size: 14px;
  cursor: pointer;
}

.processedDetail .checkallbox:hover {
  color: #409eff;
}

.processedDetail .checkallbox-oop:hover {
  color: #409eff;
}

.processedDetail .blank {
  color: #606266;
  text-decoration: none;
}

.processedDetail .createOrder {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 10px;
}

.processedDetail .createOrder-item {
  margin: 0 10px;
}

.processedDetail .el-dropdown-link {
  color: #606266 !important;
}

/* 	.loading-box{
		display: inline-block;
		height: 30px;
	} */

.processedDetail .list-desc {
  display: flex;
  align-items: center;
  margin-left: 15px;
  border-bottom: 1px #eee solid;
}

.processedDetail .titl_desc_left {
  display: flex;
}

.processedDetail .chekbox {
  width: 30px;
  height: 30px;
  line-height: 30px;
}

.processedDetail .pic-box {
  display: flex;
  margin: 2px;
  width: 80px;
  height: 80px;
}

.processedDetail .return-item {
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 10px;
  font-size: 14px;
}

.processedDetail .return-item-list {
  display: flex;
  align-items: center;
}

.processedDetail .unfold:nth-of-type(n + 4) {
  display: none;
}

.processedDetail .pic-box-desc {
  width: 250px;
  margin-left: 20px;
}

.processedDetail .retrun-reasonr {
  margin-left: 30px;
}

.processedDetail .retrun-reasonr-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 20px;
}

.processedDetail .seller {
  margin-right: 10px;
  font-size: 18px;
}

.processedDetail .return-reasonr-desc {
  box-sizing: border-box;
  padding: 3px 0;
}

.processedDetail .seller-item {
  margin-left: 15px;
  font-size: 14px;
}

.processedDetail .seller-ppc {
  color: red;
}

.processedDetail .ppo_box {
  /* display: flex;
			justify-content: space-between;
		    flex-wrap: wrap;
			height: 40px; */
  padding: 5px 10px;
  margin: 0px -5px;
  -webkit-box-align: center;
  align-items: center;
  background: rgb(61, 70, 77);
  color: rgb(255, 255, 255);
  border-top: 10px solid rgb(255, 255, 255);
  border-bottom: 10px solid rgb(255, 255, 255);
  border-radius: 2px;
}

.ppo-item {
  font-size: 20px;
  color: #fff;
  margin-right: 10px;
}

.ordersn-box {
  font-size: 12px;
}

.pic-wrapper {
  display: inline-block;
  width: 40px;
  height: 40px;
  margin-right: 5px;
  position: relative;
}

.pic-wrapper-quantity {
  position: absolute;
  top: 0;
  right: 0;
  display: inline-block;
  width: 15px;
  height: 15px;
  line-height: 15px;
  background-color: red;
  font-size: 8px;
  color: #fff;
  text-align: center;
}

.IdScaneArea .el-input__inner {
  width: 99%;
  height: 130px;
  font-size: 30px;
}

.flagbox {
  display: inline-block;
  width: 56px;
  height: 30px;
}

.flagbox .el-radio {
  display: flex;
  align-items: center;
}

.flagbox .el-radio__label {
  padding-left: 5px !important;
}
</style>
